<template>
  <div class="row">
    <div class="col col-12">
      <input class="form-control" :value="valueMutable" readonly>
    </div>
    <div class="col-md-2 mt-1">
      <div class="btn-group">
        <button
          v-if="level && ['empresa'].indexOf(level) >= 0"
          class="btn btn-outline-secondary"
          v-b-tooltip="'Editar'"
          @click="openEdit"
        >
          <span class="material-icons">edit</span>
        </button>
      </div>
    </div>
    <b-modal
      id="modalEdit"
      ref="modalEdit"
      title="Editor online"
      size="xl"
      hide-footer
    >
      <b-spinner
        v-if="loadContent"
        variant="primary"
        size="18"
      />
      <b-card-text v-if="!loadContent">
        <div class="preview">
          <div class="row">
            <div class="col-6 col-md-6">
              <h4>Configuración global</h4>
              <vue-json-editor
                v-model="global"
                mode="view"
                :modes="['view','code']"
                :show-btns="false"
                :expandedOnStart="true"
              />
            </div>
            <div class="col-6 col-md-6">
              <h4>Configuración de la empresa</h4>
              <vue-json-editor
                v-model="content"
                mode="code"
                :modes="['code']"
                :show-btns="false"
                :expandedOnStart="true"
              />
            </div>
          </div>
        </div>
      </b-card-text>
      <vs-progress
        v-if="progress.enabled"
        :percent="progress.percent"
        :indeterminate="progress.indeterminate"
        :color="color"
      />
      <div class="text-center" v-if="!loadContent">
        <button class="btn" @click="saveData">
          Aceptar
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import vueJsonEditor from 'vue-json-editor';

import { ioGetParameter } from '@/febos/servicios/api/herramientas.api';
import InputConfigMixin from '@/febos/global/empresas/componentes/configs/inputs/InputConfigMixin';

export default {
  name: 'ConfigInputS3Json',
  mixins: [InputConfigMixin],
  components: {
    vueJsonEditor
  },
  data: () => ({
    loadContent: false,
    valueMutable: '',
    viewHtml: false,
    global: {},
    content: {},
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    }
  }),
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  mounted() {
    this.valueMutable = this.value;
  },
  methods: {
    ...mapActions('Empresas', [
      'saveParameter'
    ]),
    input(newValue) {
      this.content = newValue;
    },
    async uploadLocalFile({ path }) {
      this.$emit('input', path);
    },
    async changeView() {
      this.viewHtml = !this.viewHtml;
    },
    async saveData() {
      if (Object.keys(this.content).length === 0) {
        return;
      }
      this.valueMutable = JSON.stringify(this.content);
      const params = { origen: this.level, app: this.application };
      if (this.selectedUserId) {
        params.usuarioId = this.selectedUserId;
      }
      this.saveParameter({
        params,
        body: { parametroId: this.param, valor: this.valueMutable }
      });
      this.$refs.modalEdit.hide();
    },
    async openEdit() {
      this.viewHtml = true;
      this.loadContent = true;
      this.$refs.modalEdit.show();
      try {
        this.loadContent = true;
        // get set config content value
        const { parametro } = await ioGetParameter({ parametro: this.param, detailed: true });
        this.global = parametro['0'] || {};
        this.content = parametro[this.company.id] || {};
      } finally {
        this.loadContent = false;
      }
    }
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    level: {
      type: String,
      required: true,
    },
    param: {
      type: String,
      required: false,
    }
  }
};
</script>
<style scoped>
.preview {
  min-height: 80vh;
}

.jsoneditor {
  min-height: 80vh;
}
</style>
